import { useEffect, useState } from "react";

const IMAGES = [
  "/imgs/hero_still2.jpeg",
  "/imgs/hero_still.jpeg",
  "/imgs/kitchen_still.png",
  "/imgs/family_still.png",
];

export default function HeroMobileSlider({
  intervalMs = 7000,
  className = "hero-image",
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % IMAGES.length);
    }, intervalMs);

    return () => clearInterval(id);
  }, [intervalMs]);

  return (
    <img
      className={className}
      src={IMAGES[index]}
      alt=""
      loading="eager"
      decoding="async"
      draggable={false}
    />
  );
}
